import { __assign, __rest } from "tslib";
import React from 'react';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentBoxEditor from '../../../../lego/CommentBoxEditor';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
import CommentSuggestions from '../../lego/CommentSuggestions';
var EditorView = function (_a) {
    var suggestions = _a.suggestions, maxVisible = _a.maxVisible, onSuggestionSelect = _a.onSuggestionSelect, rest = __rest(_a, ["suggestions", "maxVisible", "onSuggestionSelect"]);
    return (React.createElement(CommentBoxLayout, { above: React.createElement(CommentSuggestions, { suggestions: suggestions, maxVisible: maxVisible, onSelect: onSuggestionSelect }), avatar: React.createElement(CommentBoxAvatar, null), content: React.createElement(CommentBoxEditor, __assign({}, rest)) }));
};
EditorView.displayName = 'EditorView';
export default EditorView;
//# sourceMappingURL=EditorView.js.map